import { getPreferredIdentifier } from '@/utils/helpers';

import { getLocationName } from '../get-location-name';
import { LocationModel } from '../types';

export const getLocationNameWithCode = (location: LocationModel) => {
  const name = getLocationName(location);
  const code = getPreferredIdentifier(location.identifiers);
  return { name, code: code?.value };
};
